import { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema, toTypedRxJsonSchema } from 'rxdb';

const instructionSchemaLiteral = {
  title: 'instruction schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 36,
      type: 'string',
    },
    userId: { type: 'string' },

    content: { type: 'string' },
    parsedContent: { type: ['string', 'null'] }, // used to display content without HTML tags
    numTokens: { type: 'number' }, // token count for name+content
    name: { type: 'string' },

    tagIds: {
      type: 'array',
      items: { type: 'string' },
    },

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    archivedAt: { type: ['string', 'null'] },
    archived: { type: 'boolean' },
  },
  required: ['id', 'userId', 'content', 'name', 'createdAt', 'updatedAt', 'archived'],
  indexes: [['archived']],
} as const;
const _instructionSchemaTyped = toTypedRxJsonSchema(instructionSchemaLiteral);

export type Instruction = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _instructionSchemaTyped>;
export const instructionSchema: RxJsonSchema<Instruction> = instructionSchemaLiteral;
